<template>
  <div class="line-container" v-if="colorList.length">
    <div class="clock-text">打卡进度</div>
    <div class="line-content">
      <div
        class="line-item"
        v-for="(item, index) in colorList"
        :key="index"
        :style="{
          height: item.height,
          backgroundColor: dealColor(item.water_color),
          opacity: computeOpacity(index)
        }"
      ></div>
    </div>
    <div class="line-flag" v-show="curStatus !== 0" :style="{ bottom: height }">
      <img
        class="flag-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b9b64198bf8055df550a91c6edafa954.png"
        alt=""
      />
      <div class="flag-dash"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    status: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      curStatus: 0,
      colorList: [
        {
          time: '08:00',
          edit: true,
          color: '#C3CDDA',
          ml: '400ml'
        },
        {
          time: '09:00',
          color: '#FF1149',
          ml: '300ml'
        },
        {
          time: '10:00',
          color: '#FF9854',
          ml: '400ml'
        },
        {
          time: '11:30',
          color: '#FFBD01',
          ml: '300ml'
        },
        {
          time: '14:00',
          color: '#49DEA5',
          ml: '400ml'
        },
        {
          time: '16:00',
          color: '#35C5F4',
          ml: '350ml'
        },
        {
          time: '18:00',
          color: '#467BF8',
          ml: '250ml'
        },
        {
          time: '20:00',
          color: '#CB80E5',
          ml: '200ml'
        }
      ],
      totalWaterVolume: 0, //总格子数
      height: '0%'
    }
  },
  computed: {},
  watch: {
    status(newval, oldval) {
      setTimeout(() => {
        this.updateData()
      }, 500)
    },
    data() {
      this.updateColor()
    }
  },
  mounted() {
    this.curStatus = this.status
    this.updateColor()
    this.updateData()
  },
  methods: {
    //处理透明颜色 变成半透明
    dealColor(str) {
      return str == 'rgba(0,0,0,0)' ? 'rgba(195, 205, 218, 1)' : str
    },
    computeOpacity(index) {
      let opacity = index < this.data.length - this.curStatus ? 0.3 : 1
      return opacity
    },
    updateData() {
      let len = this.colorList.length - this.status
      let drinkVolume = 0
      for (let i = 0; i < len; i++) {
        drinkVolume += this.colorList[i].water_volume
      }
      this.height =
        ((this.totalWaterVolume - drinkVolume) / this.totalWaterVolume) * 100 +
        '%'
      setTimeout(() => {
        this.curStatus = this.status
      }, 500)
    },
    updateColor() {
      let res = []
      this.totalWaterVolume = this.data.reduce((pre, cur) => {
        return pre + cur.water_volume
      }, 0)
      this.data.map((item) => {
        let obj = {}
        obj.water_color = item.water_color
        obj.water_volume = item.water_volume
        obj.height =
          ((item.water_volume / this.totalWaterVolume) * 100).toFixed(2) + '%'
        res.push(obj)
      })
      this.colorList = res
    }
  }
}
</script>
<style lang="scss" scoped>
.line-container {
  height: 100%;
  position: relative;
  display: flex;
  align-items: flex-end;

  .clock-text {
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.6);
    line-height: 17px;
    position: absolute;
    left: 50%;
    top: -16px;
    white-space: nowrap;
    transform: translate(-66%, -100%);
  }

  .line-content {
    width: 16px;
    height: 100%;
    border-radius: 45px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow: hidden;

    .line-item {
      height: 32px;
    }
  }

  .line-flag {
    position: absolute;
    right: -8px;
    /*  top: 0%; */
    width: 36px;
    height: 28px;
    transform: translate(0%, 50%);
    transition: bottom 0.3s linear;

    .flag-image {
      width: 100%;
      height: 100%;
    }

    .flag-dash {
      position: absolute;
      right: 100%;
      top: 50%;
      width: 29px;
      transform: translate(0%, -50%);
      height: 0px;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.3);
    }
  }
}
</style>
